import { sdGatewayClient } from '../http/sdGatewayClient';
import { SDUser } from '../models/SDUser';

type OAuthCallbackResponse = {
  csrfToken: string;
  authTkt: string;
  sessionId: string;
  user: SDUser;
};

export const oAuthService = {
  async getTokensFromAuthCode(code: string) {
    const response = await sdGatewayClient.get<OAuthCallbackResponse>('/oauth_callback', { params: { code } });
    return response.data;
  },

  async refreshAccessToken(refreshToken: string) {
    const response = await sdGatewayClient.get<OAuthCallbackResponse>('/oauth_callback', { params: { refreshToken } });
    return response.data;
  },

  async getUserDetails(username: string): Promise<SDUser> {
    return (await sdGatewayClient.get<SDUser>('/userDetails', { params: { username } })).data;
  },

  /**
   * Verify auth against the backend
   * If the session is in need of refreshing, the server will return a new
   * authTkt which should replace any existing ones kept in storage
   */
  async verifyAuthWithServer() {
    const response = await sdGatewayClient.get<{ message: string; authTkt?: string }>('/verifyAuth');
    return response.data;
  },

  async keepSessionAlive() {
    // TODO: Refresh a token to keep session alive
    throw new Error('Not implemented');
  },

  async sloCallback() {
    await sdGatewayClient.get<void>('/slo_callback');
  },

  async keepLegacySellerDashboardSessionAlive() {
    // TODO: Make a call to the legacy SD app to keep it's
    // session alive. Not 100% sure this is needed but it's likely.
    throw new Error('Not implemented');
  }
};
